import { LocalDate, LocalTime } from "js-joda";

import { Locale } from "@plex/culture-core";

import { ITokenItem, TokenFormat } from "../types/Token.types";

export const createTextPreview = (translatedText: string, tokens: ITokenItem[], localeIdentifier?: string) => {
  try {
    const locale = new Locale(localeIdentifier ?? "en-US");

    tokens.forEach((token: ITokenItem) => {
      if (token.type === TokenFormat.Date && !token.value) {
        token.value = LocalDate.now();
      }

      if (token.type === TokenFormat.Time && !token.value) {
        token.value = LocalTime.now();
      }
    });
    const tokenValues = tokens.reduce((prop, token) => {
      prop[token.name] = token.value ? token.value : token.name;
      return prop;
    }, {});

    const result = locale.messages.parse(translatedText)(tokenValues);
    return result;
  } catch (error) {
    return error.messageId;
  }
};
